module.exports = __webpack_public_path__ + "static/media/game.957985ee.gif";